import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * True once the user has completed at least one exchange —
 * a swap, a lend (as owner or borrower), or a donation (given or received).
 */
export function useHasCompletedTransaction(userId: string | undefined) {
  const [state, setState] = useState<{ loading: boolean; eligible: boolean }>({
    loading: true,
    eligible: false,
  });

  useEffect(() => {
    if (!userId) {
      setState({ loading: false, eligible: false });
      return;
    }
    let cancelled = false;
    (async () => {
      const asRequester = supabase
        .from("exchange_requests")
        .select("id")
        .eq("status", "completed")
        .eq("requester_id", userId)
        .limit(1);
      const asOwner = supabase
        .from("exchange_requests")
        .select("id, books!inner(user_id)")
        .eq("status", "completed")
        .eq("books.user_id", userId)
        .limit(1);

      const [r1, r2] = await Promise.all([asRequester, asOwner]);
      if (cancelled) return;
      const eligible = (r1.data?.length ?? 0) > 0 || (r2.data?.length ?? 0) > 0;
      setState({ loading: false, eligible });
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return state;
}
